import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";

import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import PreviewPaginationComponents from "components/DesignSystemPage/PaginationComponent/PreviewPaginationComponent";
import UsagePaginationComponent from "components/DesignSystemPage/PaginationComponent/UsagePaginationComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";

import { paginationTokenTabData } from "assets/data/tokenTabData";
import { getComponentsSideData } from "assets/data/sideTabData";
import "assets/scss/pages/_DesignSystemComponents.scss";

const PaginationComponents = () => {
	const { id } = useParams();
	const { designSystemMeta, designSystem } = useGlobalContext();

	const tabData = ["Default"];
	const tabs = ["Preview", "Usage", "Tokens"];

	const componentName = "pagination";
	const componentKey = `Component/${componentName}`;
	const componentData = designSystem[componentKey];
	const tokenTableData = paginationTokenTabData(componentData, componentName);

	const [activeTab, setActiveTab] = useState(0);
	const [selectedTab, setSelectedTab] = useState(0);

	const handleTabClick = (index) => {
		setActiveTab(index);
	};

	const bannerData = {
		heading: "Pagination",
		description: "Add, replace, generate colors which makes your design looks awesome!",
		bannerImage: designSystemMeta.banner_url,
	};

	const renderContent = () => {
		switch (selectedTab) {
			case 0:
				return (
					<PreviewPaginationComponents
						tabData={tabData}
						activeTab={activeTab}
						handleTabClick={handleTabClick}
						setSelectedTab={setSelectedTab}
					/>
				);
			case 1:
				return <UsagePaginationComponent />;
			case 2:
				return <TokenTableComponent tokenTableData={tokenTableData} />;
			default:
				return null;
		}
	};
	return (
		<DesignSystemLayout
			bannerData={bannerData}
			selectedTab={selectedTab}
			setSelectedTab={setSelectedTab}
			tabs={tabs}
			sideTabs={getComponentsSideData(id)}
			title="Components"
		>
			{renderContent()}
		</DesignSystemLayout>
	);
};

export default PaginationComponents;
